// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Convection } from './Convection';
import { Airspace } from './Airspace';
import { Volume } from './Volume';
import { VolumePrism } from './VolumePrism';
import { PrismRange } from './PrismRange';
import { Polygon2D } from './Polygon2D';
import { Coordinate } from './Coordinate';

export class ShowConvectionsRequest implements IShowConvectionsRequest {
    convections!: Convection[];

    constructor(data?: IShowConvectionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["convections"])) {
                this.convections = [] as any;
                for (let item of _data["convections"])
                    this.convections!.push(Convection.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShowConvectionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ShowConvectionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.convections)) {
            data["convections"] = [];
            for (let item of this.convections)
                data["convections"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IShowConvectionsRequest {
    convections: Convection[];
}